import { get } from 'dpl/shared/utils/object';

import { BYPASSED_HUB_UIDS } from './constants';
import { DOCUMENT_TYPE_TO_DATA_TYPES } from './documentTypeToDataTypes';

export function getArticlePath(document) {
  const uid1 = get(document, 'data.hub_page.uid');
  const uid2 = document.uid;

  if (!(uid1 || uid2)) {
    return null;
  }

  const path = [uid1, uid2].filter(Boolean).join('/');

  if (BYPASSED_HUB_UIDS.some(uid => [uid1, uid2].includes(uid))) {
    return `/${path}`;
  }

  return `/a/${path}`;
}

export function getFetchLinks(documentType) {
  return documentType
    .map(t => {
      const dataTypes = DOCUMENT_TYPE_TO_DATA_TYPES[t];

      if (!dataTypes) {
        // eslint-disable-next-line no-console
        console.warn(
          `getFetchLinks: documentType to dataTypes not found for type ${t}`
        );
        return '';
      }

      return `${t}.${Object.values(dataTypes).join(`,${t}.`)}`;
    })
    .join(',');
}

export function isPrismicPreviewPage() {
  return window.__DPL_PRISMIC_PREVIEW_PAGE;
}

function isBuyerAllowedAccess(user, permissionTypes) {
  if (!user.isBuyer) {
    return false;
  }

  return permissionTypes.some(p => user.value.data.entitlements.includes(p));
}

function isBreederAllowedAccess(user, permissionTypes) {
  if (!user.isBreeder) {
    return false;
  }

  if (
    user.value.data.approved &&
    permissionTypes.includes('approved_breeders')
  ) {
    return true;
  }

  if (
    (user.value.data.approved || user.value.data.quiz_complete) &&
    permissionTypes.includes('questionnaire_complete')
  ) {
    return true;
  }

  return false;
}

export function isAllowedAccess(user, permissionTypes) {
  if (permissionTypes.length === 0) {
    return true;
  }

  return (
    isBuyerAllowedAccess(user, permissionTypes) ||
    isBreederAllowedAccess(user, permissionTypes)
  );
}
